
import es from './es'

let language: {[key:string]:string} = es;

// export const t = window.location.hostname.includes('pre') || window.location.hostname.includes('localhost') ?
//     (key:string)=>language[key]||('·'+key+'·'):
//     (key:string)=>language[key]||key;

export const t = (key:string)=>language[key]||key;

export const setLanguage = async (code:string)=>{
    // no se puede usar un import con variable,
    // asi parcel detecta los imports lazy
    if(code === 'es') language = es;
    else if(code === 'it') language = (await import('./it')).default;
}
